import { AttachInternalController } from '@nx-paeonia/utils-dom';
import { debounce } from '@nx-paeonia/utils-events';
import { css, html, LitElement, type PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import { formDataFrom, type SupportedInput } from './value.helpers.js';

export class MirroredInputComponent extends LitElement {
  static readonly formAssociated = true;

  private readonly _internals = new AttachInternalController(this);

  @property({ type: String, attribute: 'mirror-key' })
  public mirrorKey = '';

  @property({ type: Boolean, attribute: 'mirror-initial' })
  public mirrorInitial = false;

  protected override firstUpdated(_changedProperties: PropertyValues): void {
    super.firstUpdated(_changedProperties);

    const debouncedInputEvent = debounce(() => {
      const input = this.querySelector<SupportedInput>('input, textarea');

      if (input && this.mirrorKey) {
        const fd = formDataFrom(input, this.mirrorKey);
        this._internals._internals.setFormValue(fd);
      }
    }, 120);

    this.addEventListener('input', debouncedInputEvent);

    const input = this.querySelector<SupportedInput>('input');
    if (this.mirrorInitial && input && this.mirrorKey) {
      this.shadowRoot?.querySelector('slot')?.addEventListener(
        'slotchange',
        () => {
          const fd = formDataFrom(input, this.mirrorKey);
          this._internals._internals.setFormValue(fd);
        },
        { once: true },
      );
    }
  }

  override render() {
    return html` <slot></slot> `;
  }

  static override get styles() {
    return [
      css`
        :host {
          display: flex;
          width: 100%;
        }

        ::slotted(input) {
          width: 100%;
        }
      `,
    ];
  }
}

export function defineMirroredInputComponent(): void {
  if (!customElements.get('y-mirrored-input')) {
    customElements.define('y-mirrored-input', MirroredInputComponent);
  }
}
